import type { TFunction } from 'i18next';
import type { ProviderFormState } from './types';

export const providerFields = {
  ALLOWED_ACCOUNTS: 'allowed_accounts',
  ALLOWED_EXPORT_TYPES: 'allowed_export_types',
  ID: 'id',
  NAME: 'name',
} as const;

export const exportTypes = {
  OA_MATCH: 'oa_match',
  BIDSTREAM: 'bidstream',
  BIDSTREAM_PLUS: 'bidstream_plus',
} as const;

export const getProvidersLabels = (t: TFunction) => ({
  [providerFields.ALLOWED_ACCOUNTS]: t('Linked Organization(s)'),
  [providerFields.ALLOWED_EXPORT_TYPES]: t('Allowed Export Types'),
  [providerFields.ID]: t('Provider ID'),
  [providerFields.NAME]: t('Provider Name'),
});

export const getExportTypesLabels = (t: TFunction) => ({
  [exportTypes.BIDSTREAM]: t('Bidstream'),
  [exportTypes.BIDSTREAM_PLUS]: t('Bidstream Plus'),
  [exportTypes.OA_MATCH]: t('Identity Graph'),
});

export const initialFormState: ProviderFormState = {
  [providerFields.ALLOWED_ACCOUNTS]: [],
  [providerFields.ALLOWED_EXPORT_TYPES]: {},
  [providerFields.ID]: '',
  [providerFields.NAME]: '',
};
